import { render, staticRenderFns } from "./Unblock.vue?vue&type=template&id=10ccd848&scoped=true&"
import script from "./Unblock.vue?vue&type=script&lang=js&"
export * from "./Unblock.vue?vue&type=script&lang=js&"
import style0 from "./Unblock.vue?vue&type=style&index=0&id=10ccd848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccd848",
  null
  
)

export default component.exports